module.exports = __webpack_public_path__ + "781190aecb862fffe858d42b124658cc.ttf";